import React from 'react';

const ReportIcon = ({ className, size = 'md' }) => {
  const sizes = {
    sm: { width: '14.67', height: '12' },
    md: { width: '24', height: '26' },
  };

  return (
    <svg
      width={sizes[size].width}
      height={sizes[size].height}
      viewBox='0 0 24 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        className={className}
        d='M14.6666 1.66666H3.99992C3.29267 1.66666 2.6144 1.94761 2.1143 2.4477C1.6142 2.9478 1.33325 3.62608 1.33325 4.33332V25.6667C1.33325 26.3739 1.6142 27.0522 2.1143 27.5523C2.6144 28.0524 3.29267 28.3333 3.99992 28.3333H19.9999C20.7072 28.3333 21.3854 28.0524 21.8855 27.5523C22.3856 27.0522 22.6666 26.3739 22.6666 25.6667V9.66666M14.6666 1.66666L22.6666 9.66666M14.6666 1.66666V9.66666H22.6666M17.3333 16.3333H6.66658M17.3333 21.6667H6.66658M9.33325 11H6.66658'
        stroke='#171717'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default ReportIcon;
